import React from 'react';

import { type RouteComponentProps, Route, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';

import { lazyWithRetry } from '../../helpers/utilities';
import ErrorBoundary from '../../layouts/Portal/ErrorBoundary';

const QROP = lazyWithRetry(() => import('./QROP'));
type Props = RouteComponentProps;

const QROPRoutes: React.FC<Props> = (props: Props) => {
  const {
    match: { path },
  } = props;

  return (
    <ErrorBoundary identifier="qrop">
      <Switch>
        <Route
          path={`${path}`}
          render={() => (
            <LazyComponent>
              <QROP />
            </LazyComponent>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default QROPRoutes;
